// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_ctx_proc = require("./MM_wrk_ctx_proc.res.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.res.js");
var MM_wrk_pattern_search = require("./MM_wrk_pattern_search.res.js");

var procName = "MM_wrk_search_asrt";

function reqToStr(req) {
  return "FindAssertions(label=\"" + req.label + "\", pattern=" + req.pattern + ")";
}

function respToStr(resp) {
  if (resp.TAG === "OnProgress") {
    return "OnProgress(pct=" + String(resp._0) + ")";
  } else {
    return "SearchResult";
  }
}

function searchAssertions(settingsVer, settings, preCtxVer, preCtx, isAxiom, typ, label, pattern, patternVersion, isDisc, isDepr, isTranDepr, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx_proc.beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, "", "", procName, {
                    TAG: "FindAssertions",
                    isAxiom: isAxiom,
                    typ: typ,
                    label: label,
                    pattern: pattern,
                    patternVersion: patternVersion,
                    ctx: preCtx,
                    isDisc: isDisc,
                    isDepr: isDepr,
                    isTranDepr: isTranDepr
                  }, (function (resp, param, endWorkerInteraction) {
                      if (resp.TAG === "OnProgress") {
                        return onProgress(resp._0);
                      }
                      endWorkerInteraction();
                      resolve(resp._0);
                    }), false);
            });
}

function frameToStmtsDto(wrkCtx, frame) {
  var newDisj = MM_context.disjMake();
  Belt_MapInt.forEach(frame.disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  MM_context.disjAddPair(newDisj, n, m);
                }));
        }));
  var newDisjStr = [];
  MM_context.disjForEachArr(newDisj, undefined, undefined, undefined, undefined, (function (disjArr) {
          newDisjStr.push(MM_context.frmIntsToStrExn(wrkCtx, frame, disjArr));
        }));
  var stmts = [];
  var argLabels = [];
  frame.hyps.forEach(function (hyp) {
        if (hyp.typ !== "E") {
          return ;
        }
        var argLabel = hyp.label;
        argLabels.push(argLabel);
        stmts.push({
              label: argLabel,
              expr: hyp.expr,
              exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, hyp.expr),
              jstf: undefined,
              isProved: false
            });
      });
  stmts.push({
        label: frame.label,
        expr: frame.asrt,
        exprStr: MM_context.frmIntsToStrExn(wrkCtx, frame, frame.asrt),
        jstf: {
          args: argLabels,
          label: frame.label
        },
        isProved: false
      });
  return {
          newVars: Belt_Array.range(0, frame.numOfVars - 1 | 0),
          newVarTypes: frame.varTypes,
          newDisj: newDisj,
          newDisjStr: newDisjStr,
          stmts: stmts
        };
}

function threeStateBoolMatchesTwoStateBool(threeStateBool, twoStateBool) {
  if (threeStateBool !== undefined) {
    return threeStateBool === twoStateBool;
  } else {
    return true;
  }
}

function doSearchAssertions(allFramesInDeclarationOrder, isAxiom, typ, label, pattern, patternVersion, ctx, isDisc, isDepr, isTranDepr, onProgress) {
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined);
  var framesProcessed = {
    contents: 0
  };
  var numOfFrames = allFramesInDeclarationOrder.length;
  var msg = MM_wrk_pattern_search.parsePattern(pattern, patternVersion, ctx);
  var pattern$1;
  pattern$1 = msg.TAG === "Ok" ? msg._0 : Js_exn.raiseError("Cannot parse the search pattern in doSearchAssertions: " + msg._0);
  var labelTrim = label.trim().toLowerCase();
  return allFramesInDeclarationOrder.map(function (frame) {
                  if (onProgress !== undefined) {
                    framesProcessed.contents = framesProcessed.contents + 1;
                    MM_progress_tracker.progressTrackerSetCurrPct(progressState, framesProcessed.contents / numOfFrames);
                  }
                  var matched = Core__Option.mapOr(isAxiom, true, (function (isAxiom) {
                          return isAxiom === frame.isAxiom;
                        })) && Core__Option.mapOr(typ, true, (function (typ) {
                          return typ === frame.asrt[0];
                        })) && frame.label.toLowerCase().includes(labelTrim) && threeStateBoolMatchesTwoStateBool(isDisc, frame.isDisc) && threeStateBoolMatchesTwoStateBool(isDepr, frame.isDepr) && threeStateBoolMatchesTwoStateBool(isTranDepr, frame.isTranDepr);
                  if (!matched) {
                    return ;
                  }
                  var idxs = MM_wrk_pattern_search.frameMatchesPattern(frame, pattern$1);
                  if (typeof idxs !== "object") {
                    return ;
                  } else {
                    return [
                            frame,
                            idxs._0
                          ];
                  }
                }).filter(function (res) {
                return Core__Option.isSome(res);
              }).map(function (__x) {
              return Core__Option.getExn(__x, undefined);
            });
}

function processOnWorkerSide(req, sendToClient) {
  var filteredFrames = doSearchAssertions(MM_wrk_ctx_proc.getAllFramesInDeclarationOrderExn(), req.isAxiom, req.typ, req.label, req.pattern, req.patternVersion, req.ctx, req.isDisc, req.isDepr, req.isTranDepr, (function (pct) {
          sendToClient({
                TAG: "OnProgress",
                _0: pct
              });
        }));
  sendToClient({
        TAG: "SearchResult",
        _0: filteredFrames.map(function (param) {
              return [
                      param[0].label,
                      param[1]
                    ];
            })
      });
}

exports.procName = procName;
exports.threeStateBoolMatchesTwoStateBool = threeStateBoolMatchesTwoStateBool;
exports.doSearchAssertions = doSearchAssertions;
exports.searchAssertions = searchAssertions;
exports.frameToStmtsDto = frameToStmtsDto;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* MM_context Not a pure module */
